import { render, staticRenderFns } from "./creator-v3-tag.vue?vue&type=template&id=09ec8c83"
import script from "./creator-v3-tag.js?vue&type=script&lang=js&external"
export * from "./creator-v3-tag.js?vue&type=script&lang=js&external"
import style0 from "./creator-v3-tag.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports